<ng-container *ngIf="!loading">
  <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-panel header={{vigenciaSolicitud.paso}}>
          <form class="form-horizontal" #formVigencia="ngForm" (ngSubmit)="formVigencia.valid && updateValidityRequest()" novalidate>
            
            <!-- Toggle Paso flujo / Tipo Referencia -->
            <div style="display: flex; align-items: center; gap: 10px; flex-wrap: nowrap;">
              <span style="font-weight: bold;">{{ 'VIGENCIADEDATOS.LBL_APPLICARVIGENCIA' | translate }}</span>     
              <ng-container *ngIf="vigenciaSolicitud.codigoPaso !== CodigoPaso.UNIDADPRODUCTIVA">
                <span>{{ 'VIGENCIADEDATOS.LBL_PASO' | translate }}</span>         
                <p-inputSwitch [(ngModel)]="vigenciaSolicitud.indicadorTipo" name="esPasoFlujo" (onChange)="tableModified = true; preUpdateValidityRequest($event)"></p-inputSwitch>
                <span>{{ ('VIGENCIADEDATOS.LBL_TIPO' | translate) + ' ' + vigenciaSolicitud.paso.toLocaleLowerCase() }}</span>
              </ng-container>
            </div>
            
            <!-- Fila con los 3 campos principales -->
            <div class="grid form-group">
              <!-- Paso flujo -->
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label for="pasoFlujo">*{{ 'VIGENCIADEDATOS.LBL_PASOFLUJO' | translate }}</label>
                  <label class="falso-combo-texto">{{ vigenciaSolicitud.paso }}</label>
                </div>
              </div>
    
              <!-- Tipo vigencia -->
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <div *ngIf="!vigenciaSolicitud.indicadorTipo; else falsoTipoVigencia">
                    <label for="tipoVigencia">*{{ 'VIGENCIADEDATOS.LBL_TIPOVIGENCIA' | translate }}</label>               
                    <p-dropdown 
                      id="tipoVigencia"
                      name="tipoVigencia"
                      [options]="listTypeValidity"
                      [(ngModel)]="vigenciaSolicitud.idTipoVigencia"
                      optionLabel="nombre"
                      optionValue="idLista"
                      placeholder="Seleccione un tipo"
                      required
                      #tipoVigencia="ngModel"
                    >
                  </p-dropdown>
                    <div *ngIf="formVigencia.submitted && !tipoVigencia.valid" class="text-danger small">
                      {{ 'VIGENCIADEDATOS.MSG_DEBESELECCIONARUNTIPODEVIGENCIA' | translate }}
                    </div>
                  </div>
                  <!-- <ng-template #falsoTipoVigencia>
                    <label class="falso-combo-texto">{{ getNombreTipoVigencia(vigenciaSolicitud.idTipoVigencia) }}</label>
                  </ng-template> -->
                </div>
              
              </div>
    
              <!-- Duración -->
              <div class="col-12 md:col-4 lg:col-4" *ngIf="!vigenciaSolicitud.indicadorTipo && !shouldHideDuration(); else falsoDuracion">
                <div class="div-form">
                  <label for="duracion">*{{ 'VIGENCIADEDATOS.LBL_VIGENCIA' | translate }}</label>
                  <div>
                    <input type="number" pInputText class="form-control" id="duracion" name="duracion"
                           [(ngModel)]="vigenciaSolicitud.duracionVigencia" required
                           (keypress)="limitToThreeDigits($event)" #duracion="ngModel"/>
                      <div class="p-message p-messages-error p-corner-all"
                          *ngIf="formVigencia.submitted && duracion && duracion.errors?.required">
                          {{ "VIGENCIADEDATOS.LBL_VIGENCIA" | translate }} {{"LBL_REQUERIDO" | translate}}
                      </div>
                      <div class="p-message p-messages-error p-corner-all"
                          *ngIf="formVigencia.submitted && duracion && vigenciaSolicitud.duracionVigencia !== null && vigenciaSolicitud.duracionVigencia <= 0">
                           {{ 'VIGENCIADEDATOS.MSG_DEBESERMAYOR' | translate }}
                      </div>
                      <div class="p-message p-messages-error p-corner-all"
                          *ngIf="formVigencia.submitted && duracion && vigenciaSolicitud.duracionVigencia > maxDuracion">
                           {{ ('VIGENCIADEDATOS.MSG_MAXDIGITOS' | translate) + ' ' + longitudMaximaDuracion + ' ' + ('VIGENCIADEDATOS.DIGITOS' | translate) }}
                      </div>
                  </div>
                </div>              
              </div>
              <!-- <ng-template #falsoDuracion>
                <div class="col-12 md:col-4 lg:col-4" *ngIf="vigenciaSolicitud.indicadorTipo && !shouldHideDuration()">
                  <div class="div-form">
                    <label for="duracion">*{{ 'VIGENCIADEDATOS.LBL_VIGENCIA' | translate }}</label>
                    <label class="falso-combo-texto">{{ vigenciaSolicitud.duracionVigencia }}</label>
                  </div>
                </div>
              </ng-template>   -->
            </div>
            <!-- Botones -->
            <div class="grid form-footer-buttons" *ngIf="!vigenciaSolicitud.indicadorTipo">
              <div class="form-group col-12">
                  <a (click)="(formVigencia.dirty === true) ? displayDialog = true : goBack()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
                  <button type="submit" pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate }}" (keydown.enter)="submit.click()"
                          #submit></button>
              </div>
            </div>
          </form>
        </p-panel>
      </div>
  </div>
  <ng-container *ngIf="vigenciaSolicitud.indicadorTipo">
      <p-panel header="{{'VIGENCIADEDATOS.LBL_VIGENCIAPERTIPOREFERENCIA' | translate }}">
        <div>
          <div class="grid">
            <div class="col-12 md:col-6 lg:col-6">
              <button type="button" pButton icon="fa fa-plus" (click)="add()"
                      label="{{ 'BTN_AGREGAR' | translate}}"></button>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                      (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table class="tabla-vigencias"
                    [columns]="columnas" 
                    [value]="vigenciaSolicitud.codigoPaso === CodigoPaso.REFERENCIA ? listTableReference : listTableSupporting" 
                    [paginator]="true" 
                    [rows]="10"
                    [responsive]="true" 
                    paginatorPosition="bottom" 
                    [globalFilterFields]="['referencia', 'respaldo', 'vigencia', 'duracionVigencia']"
                    #dt>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                            class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                        </th>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                    <tr>
                      
                      <td>
                        <ng-container *ngIf="row.isNew; else textoReferencia">
                          <p-dropdown
                          [options]="disponiblesPorFila.get(row) || []"
                          [ngModel]="getTipoSeleccionado(row)"
                          (ngModelChange)="setTipoSeleccionado($event, row)"
                          placeholder="Seleccionar"
                          [name]="'tipo' + i"
                          [autoWidth]="false"
                          (onChange)="tableModified = true;vigenciaSolicitud.codigoPaso === CodigoPaso.REFERENCIA ? row.referencia = getLabelTipoReferencia(row.idTipoReferencia) : row.respaldo = getLabelTipoVigencia(row.idTipoRespaldo)"
                          class="dropdown-column">
                        </p-dropdown>
                        </ng-container>
                        <ng-template #textoReferencia>
                          <span>{{ getTipoReferenciaNombre(vigenciaSolicitud.codigoPaso === CodigoPaso.REFERENCIA ? row.idTipoReferencia : row.idTipoRespaldo) }}</span>
                        </ng-template>
                      </td>
                      
                      <td>
                        <p-dropdown 
                          [options]="listTypeValidityColumn"
                          [(ngModel)]="row.idTipoVigencia"
                          placeholder="Seleccionar"
                          [autoWidth]="false"
                          (onChange)="tableModified = true; row.vigencia = getLabelTipoVigencia(row.idTipoVigencia)"
                          class="dropdown-column">
                        </p-dropdown>
                      </td>
                      
                      <td>
                        <input 
                        *ngIf="!esSinVigencia(row.idTipoVigencia)"
                        type="text" 
                        pInputText
                        class="form-control" 
                        [(ngModel)]="row.duracionVigencia"
                        required
                        (keydown)="limitToThreeDigits($event)"
                        (blur)="validateValue($event, row)"
                        (copy)="$event.preventDefault()"
                        (cut)="$event.preventDefault()"
                        (input)="tableModified = true"
                        class="input-column"/>
                      </td>
                      
                        <td class="text-center">
                        <div class="btn-group" role="group">
                            <button type="button" icon="fa fa-trash" class="ui-button-success" data-toggle="tooltip" title="{{'BTN_ELIMINAR' | translate}}"
                                pButton (click)="tableModified = true; confirmDelete(row)"></button>
                        </div>
                        </td>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length" class="text-center">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                        </td>
                    </tr>
                    </ng-template>
            </p-table>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
              <a (click)="tableModified ? displayDialog = true : goBack()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
              <button type="submit" pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate }}" (click)="saveTableData()"
                      #submit></button>
          </div>
        </div>
      </div>
      </p-panel>
  </ng-container>
</ng-container>
<app-loading *ngIf="loading"></app-loading>
<p-dialog header="{{ 'LBL_CONFIRMACION' | translate }}"
          [(visible)]="displayDialog"
          [responsive]="true"
          [modal]="true">
	<p>{{ 'VIGENCIADEDATOS.MSG_CONFIRMAGUARDAR' | translate }}</p>
	<p-footer>
		<div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
			<button type="button" pButton icon="fa fa-close" (click)="displayDialog=false" label="{{ 'BTN_NO' | translate }}"></button>
			<button type="button" pButton icon="fa fa-check" (click)="goBack()" label="{{ 'BTN_SI' | translate }}"></button>
		</div>
	</p-footer>
</p-dialog>
<p-dialog header="{{ 'LBL_CONFIRMACION' | translate }}"
          [(visible)]="displayConfirmDelete"
          [modal]="true"
          [responsive]="true">
  <p>{{ 'VIGENCIADEDATOS.MSG_CONFIRMAELIMINAR' | translate }}</p>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" pButton icon="fa fa-close" (click)="displayConfirmDelete=false" label="{{ 'BTN_NO' | translate }}"></button>
      <button type="button" pButton icon="fa fa-check" (click)="eliminarFila()" label="{{ 'BTN_SI' | translate }}"></button>
    </div>
  </p-footer>
</p-dialog>

